// extracted by mini-css-extract-plugin
module.exports = {"statusBar":"styles_statusBar__1kxwK","warning":"styles_warning__1q6YA","error":"styles_error__Zj9TR","cursorInfo":"styles_cursorInfo__JD1O-"};